import EFPicture from '@elem/ui/ef-picture';
import styled from './index.module.scss';

export default function Certification() {
    const list = [
        'https://websiteoss.ecoflow.com/upload/image/1751938851296/computerbild.png',
        'https://websiteoss.ecoflow.com/upload/image/1751938851895/connect.png',
        'https://websiteoss.ecoflow.com/upload/image/1751938851495/heise.png',
        'https://websiteoss.ecoflow.com/upload/image/1751938851200/home_smart.png',
        'https://websiteoss.ecoflow.com/upload/image/1751938851684/computerbase.png',
    ];
    return (
        <div className={styled.Certification}>
            <ul className="certification-list">
                {list.map((item, index) => (
                    <li className={`certification-item item-${index}`} key={index}>
                        <EFPicture src={item} />
                    </li>
                ))}
            </ul>
        </div>
    );
}
